import React, { FC, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { selectRetouchingPreCartOffers } from '../../../selectors';

interface RetouchingPreCartOfferProps {
  children: ReactNode;
}

// A /v3/cart route gate: an order with photos added since its last retouching
// offer goes to the pre-cart retouching screen first, so the cart never paints.
// Each return to the cart re-runs it, one order at a time.
const RetouchingPreCartOffer: FC<RetouchingPreCartOfferProps> = ({
  children,
}) => {
  const offers = useSelector(selectRetouchingPreCartOffers);

  if (offers.length > 0) {
    return (
      <Redirect
        to={`/v3/retouching?offer=precart&orderKey=${encodeURIComponent(
          offers[0].orderKey,
        )}`}
      />
    );
  }

  return <>{children}</>;
};

export default RetouchingPreCartOffer;
